import debounce from "lodash/debounce";

class MobileWindowHeight {
  constructor() {
    this.splash = document.getElementById("splash");
    this.nav = document.getElementById("navbar");
    this.initialBrowswerWidth = window.innerWidth;
    this.setSplashHeight();
    this.setNavHeight();
    this.events();
  }

  events() {
    window.addEventListener(
      "resize",
      debounce(() => {
        console.log("resize debounce ran");
        this.currentBrowserwidth = window.innerWidth;
        if (this.currentBrowserwidth != this.initialBrowswerWidth) {
          console.log("browser width change");
          this.setSplashHeight();
        }
        this.setNavHeight();
      }, 333)
    );
  }

  setSplashHeight() {
    this.splash.style.height = `${window.innerHeight}px`;
  }

  setNavHeight() {
    if (window.innerWidth <= 768) {
      this.nav.style.height = `${window.innerHeight}px`;
    } else {
      this.nav.style.height = "auto";
    }
  }
}

export default MobileWindowHeight;
